import { styled } from '@mui/material'

export const CellRendererRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '100%',
})
